import { KMark } from "@/components/KMark";

export default function Splash() {
  return (
    <div className="fixed inset-0 z-[100] bg-ink flex flex-col items-center justify-center" data-testid="splash-screen">
      <div className="animate-fade-up">
        <KMark size={80} />
      </div>
      <p className="mt-6 overline animate-fade-up" style={{ animationDelay: "200ms" }}>
        Good hair isn't luck
      </p>
    </div>
  );
}
